// ChatAuthor.js — avatar + pseudo d'un expéditeur de message, résolu depuis son user_id (via userCache).
// Remplace l'affichage du username brut (souvent un id aléatoire type « tuRkjHSyXY ») dans les chats.
import React, { useEffect, useState } from 'react';
import { AvatarInner } from './HeroAvatar';
import { resolveUser, cachedUser, onUserCache } from '../services/userCache';

export default function ChatAuthor({ senderId, fallback, size = 20 }) {
  const [, tick] = useState(0);
  useEffect(() => { resolveUser(senderId); return onUserCache(() => tick((n) => n + 1)); }, [senderId]);
  const u = cachedUser(senderId);
  const name = (u && u.name) || (fallback && !/^[0-9a-f-]{6,}$/i.test(fallback) ? fallback : 'joueur');
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '.3rem', verticalAlign: 'middle' }}>
      <span style={{ width: size, height: size, borderRadius: '50%', overflow: 'hidden', flexShrink: 0, display: 'inline-flex' }}>
        <AvatarInner url={u && u.avatar} name={name} size={size} />
      </span>
      <b>{name}</b>
    </span>
  );
}
